import { useQuery } from '@tanstack/react-query';
import { rankingsApi } from '../api/rankingsApi';
import { seoKeys } from '../queryKeys';

/** Where the practice ranks for each search term, this week (Sam's weekly check). */
export function useRankTable(locationId: string) {
  return useQuery({
    queryKey: seoKeys.rankTable(locationId),
    queryFn: () => rankingsApi.get(locationId),
    enabled: !!locationId,
  });
}
